export default ({ loading }) => loading
